import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ReactNode } from 'react'
import { TenderSection } from 'components/TenderSection'
import { Box } from '@mui/material'

const accordiionSummeryVariantStyles = {
  primary: {
    backgroundColor: '#FFF',
    color: '#000',
  },
  secondary: {
    backgroundColor: 'primary.main',
    color: '#FFF',
    '&.Mui-expanded svg': {
      fill: '#FFF',
    },
  },
  error: {
    backgroundColor: '#f14433',
    color: '#FFF',
    '&.Mui-expanded svg': {
      fill: '#FFF',
    },
  },
  success: {
    backgroundColor: 'rgb(63, 161, 14)',
    color: '#FFF',
    '&.Mui-expanded svg': {
      fill: '#FFF',
    },
  },
} as const

type Props = {
  title: string
  additionalTitle?: ReactNode
  children: ReactNode
  noMargin?: boolean
  defaultExpanded?: boolean
  variant?: 'primary' | 'secondary' | 'error' | 'success'
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void
}

export function CollapsibleSection({
  title,
  additionalTitle,
  children,
  noMargin,
  defaultExpanded = true,
  variant = 'primary',
  onChange,
}: Props) {
  return (
    <Box sx={{ mb: noMargin ? 0 : 2 }}>
      <Accordion defaultExpanded={defaultExpanded} onChange={onChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{ ...accordiionSummeryVariantStyles[variant] }}
        >
          <TenderSection collapsible title={title} rightSide={additionalTitle} />
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Box>
  )
}
